import { useCompany } from '@/hooks/useCompany'
import { SuppressionScreen } from './suppressions/SuppressionScreen'

export function SettingsSuppressions() {
  const { companyId } = useCompany()

  if (!companyId) {
    return (
      <div className="px-6 py-4 max-w-7xl mx-auto">
        <div className="space-y-4">
          <div>
            <h2 className="text-xl font-semibold text-slate-900 dark:text-white">Suppression</h2>
            <p className="text-sm mt-1 text-slate-600 dark:text-slate-400 max-w-prose">
              People and companies excluded from this company's marketing email.
            </p>
          </div>
          <div className="mt-6 p-4 rounded-lg bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800">
            <p className="text-sm text-amber-700 dark:text-amber-300">No company selected.</p>
          </div>
        </div>
      </div>
    )
  }

  return <SuppressionScreen clientCompanyId={companyId} />
}
